import { AOL_RI } from 'constants/aol/aol'

// This also prevents the 'coming soon' from showing in other sections,
// but will need a BE fix to make this a reusable feature
const COMING_SOON_AOLS = [AOL_RI]

// Sections that need a plainer "Coming Soon" label instead of the dated one
const COMING_SOON_OVERRIDES: Record<string, string> = {} // leaving this logic in in case we need it again later

export const comingSoonText = (aol?: string | string[], sectionId?: string): string | null => {
  const aols = Array.isArray(aol) ? aol : (aol !== undefined ? [aol] : [])
  if (!aols.some(a => COMING_SOON_AOLS.includes(a))) return null
  if (sectionId !== undefined && COMING_SOON_OVERRIDES[sectionId] !== undefined) return COMING_SOON_OVERRIDES[sectionId]
  return 'Coming Soon'
}
